import { render, staticRenderFns } from "./SuratEdaranDll.vue?vue&type=template&id=5768b17c&"
import script from "./SuratEdaranDll.vue?vue&type=script&lang=js&"
export * from "./SuratEdaranDll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports